import {IMessageData, IRouteDefinitionParams, IRuleset, TRouteId} from "../../../index";
import {createErrorMessage} from "../../../util/misc";
import {nsRoute} from "../../../util/route";
import {
    getRouteDefinition,
    getTopParent,
    setRouteHash
} from "../../../constants/RouteDefinitions";
import pubsub from "../../../pubsub";
import {RequestRouteData} from "../../../req/RequestRouteData";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import * as ko from "knockout";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import detailsHtml from './details.html?raw';

export let template: string = detailsHtml;

export class viewModel extends ParsedRouteDataDecorator {

    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly data: KnockoutObservable<IRuleset | null> = ko.observable(null);

    constructor(params: IRouteDefinitionParams) {
        super(params);
        pubsub.on(this, 'delete.ruleset.complete', () => {
            const parent = getTopParent(this.__routeId);
            if (parent) {
                setRouteHash(parent);
            }
        });
        this.request();
    }

    private request() {
        this.messageData({message: REQUEST_MESSAGE});
        this.isReady(false);
        this.__requestRouteData
            ?.request()
            .then((data: IRuleset[]) => {
                const ruleset = data[0];
                if (!ruleset) {
                    return;
                }
                this.data(ruleset);
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))));
    }

    private getComponentParams(routeId: TRouteId): IRouteDefinitionParams {
        return this.__getParams({
            __id: this.__id,
            __isDialog: this.__isDialog,
            __routeParams: {id: this.__id},
            __requestRouteData: new RequestRouteData(getRouteDefinition('rulesetdetails')!, {id: this.__id}),
            __routeDef: getRouteDefinition(routeId)!
        })
    }

    override dispose() {
        super.dispose();
        pubsub.off(this);
    }

}
